import { InvitacionEnviarInvitacionEmpresaGestionadaAsesoriaCommandProps } from "api/Commands/InvitacionEnviarInvitacionEmpresaGestionadaAsesoriaCommand"

export interface FormValues {
  tabSelected: number
  simple: InvitacionEnviarInvitacionEmpresaGestionadaAsesoriaCommandProps[]
  policitySimple: boolean
  policityMasive: boolean
  showModalPolicitySimple: boolean
  showModalPoliciyMasive: boolean
  masive: {
    archive:
      | InvitacionEnviarInvitacionEmpresaGestionadaAsesoriaCommandProps[]
      | null
    options: InvitacionEnviarInvitacionEmpresaGestionadaAsesoriaCommandProps
  }
}

export interface SetFieldValueFunction {
  (
    field: string,
    value: string | number | boolean | object | null,
    shouldValidate?: boolean
  ): void
}

export interface ComponentFormInvitacion {
  key: string
  values: FormValues
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  errors: $TSMigrationFixMe
  setFieldValue: SetFieldValueFunction
}

export const adapterSimpleAsesoria = (values: FormValues) => {
  return {
    invitaciones: values.simple?.filter(
      (item) =>
        item.nif !== null || item.razonSocial !== null || item.email !== null
    ),
  }
}

export const adapterMasiveAsesoria = (values: FormValues) => {
  const { archive, options } = values.masive

  if (!archive) {
    return { invitaciones: [] }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const elementPost = archive.map((item: $TSMigrationFixMe) => ({
    nif: item[options?.nif ?? ""],
    razonSocial: item[options?.razonSocial ?? ""],
    email: item[options?.email ?? ""],
  }))

  return {
    invitaciones: elementPost.filter(
      (item) =>
        item.nif !== null || item.razonSocial !== null || item.email !== null
    ),
  }
}

export const OPTIONS_DROP = [
  { id: "nif", value: "NIF" },
  { id: "razonSocial", value: "Razón Social" },
  { id: "email", value: "Email" },
]

export const verificarRepeticion = (
  datos: InvitacionEnviarInvitacionEmpresaGestionadaAsesoriaCommandProps
) => {
  const valores = Object.values(datos)
  const valoresUnicos = new Set(valores)
  return valoresUnicos.size < valores.length
}
